module.exports = __webpack_public_path__ + "img/logo-gi.19be9584.svg";